import { Trigger } from '../../entities/applicant_tracking/Trigger';

export const createBlankTrigger = () => {
  return {
    uniqueKey: window.crypto.randomUUID(),
  } as Trigger;
};
